import { themeOpts as baseTheme } from '@mayoral/ui/theme/abelandlula';
import { createTheme } from '@mui/material';

const theme = createTheme({
  ...baseTheme,
});

export default theme;
